import { useTranslation } from 'react-i18next'
import Button from 'mixtiles-web-common/ui/Button'
import * as S from './EmptyBag.styles'

type EmptyBagProps = {
  onShopNowClick: () => void
}

export default function EmptyBag({ onShopNowClick }: EmptyBagProps) {
  const { t } = useTranslation()

  return (
    <S.Container data-testid="cart-empty-state">
      <S.Title>{t('order.empty_bag_title')}</S.Title>
      <Button onClick={onShopNowClick} testId="empty-bag-shop-now">
        {t('order.empty_bag_cta')}
      </Button>
    </S.Container>
  )
}
